export default {"src":"/_next/static/media/positivity_icon.179c8814.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};